// Updates the static order-summary panel (left side / mobile bar) to reflect a
// just-resolved fast-track network + amount. Called from each fast-track step
// controller on connect so the user sees the auto-selected network everywhere.
//
// BlockchainProgressController.connect() also reads `#checkout_payment_method`'s
// text content to populate the post-payment Network field, so this also has the
// side-effect of fixing the otherwise-empty Network column on the success view.
export function syncCheckoutOverview({ networkName, amountDisplay } = {}) {
  const trimmedAmount = (amountDisplay || "").trim();
  const amountWithCurrency = trimmedAmount ? `${trimmedAmount} USD` : "";
  const trimmedNetwork = (networkName || "").trim();

  const checkoutTotalAmount = document.getElementById("checkout_total_amount");
  if (checkoutTotalAmount && amountWithCurrency) {
    checkoutTotalAmount.textContent = amountWithCurrency;
  }

  const checkoutPriceMobile = document.getElementById("checkout_price_mobile");
  if (checkoutPriceMobile && amountWithCurrency) {
    checkoutPriceMobile.textContent = amountWithCurrency;
  }

  const checkoutPaymentMethod = document.getElementById("checkout_payment_method");
  if (checkoutPaymentMethod && trimmedNetwork) {
    checkoutPaymentMethod.textContent = `${trimmedNetwork} / USD`;
  }
}
